module.exports = {
  DRAG_TYPE_CLASS: 'ClassDragItem',
  DRAG_TYPE_GROUP: 'GroupDragItem',
  DRAG_TYPE_LEARNER: 'LearnerDragItem',
  DRAG_TYPE_TABLE_ROW: 'TableRowDragItem',
  DRAG_TYPE_QUESTION: 'QuestionDragItem',
  DRAG_TYPE_TOPIC: 'TopicDragItem',
  DRAG_TYPE_FRAMEWORK: 'FrameworkDragItem',
  DRAG_TYPE_FRAMEWORK_OBJECTIVE: 'FrameworkObjectiveDragItem',
  DRAG_TYPE_OBSERVATION_NOTE: 'ObservationNoteDragItem',
  DRAG_TYPE_ASSESSMENT_SCHEME_JUDGEMENT: 'AssessmentSchemeJudgementDragItem',
  DRAG_TYPE_ANSWER: 'AnswerDragItem',
  DRAG_TYPE_ASSESSMENT: 'AssessmentDragItem',
  DRAG_TYPE_SINGLE: 'SingleItem',
};
